import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiOg } from './client';
const PATH = '/api/v1/admin/bot-screen-images';
const KEY = ['og', 'bot-screen-images'];
export function useBotScreenImages(enabled = true) {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiOg('users', PATH),
        enabled,
        // A throttled admin route must not be hit again before the operator retries.
        retry: false,
    });
}
function variantPath({ screen, variant }) {
    return `${PATH}/${encodeURIComponent(screen)}/${encodeURIComponent(variant)}`;
}
export function useUploadBotScreenImage() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ file, ...target }) => {
            const form = new FormData();
            form.append('file', file);
            return apiOg('users', variantPath(target), {
                method: 'PUT',
                body: form,
            });
        },
        onSuccess: (saved, target) => {
            queryClient.setQueryData(KEY, (catalog) => catalog?.map((screen) => screen.screen === target.screen
                ? {
                    ...screen,
                    variants: [
                        ...screen.variants.filter((variant) => variant.variant !== saved.variant),
                        saved,
                    ],
                }
                : screen));
        },
    });
}
export function useDeleteBotScreenImage() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (target) => apiOg('users', variantPath(target), { method: 'DELETE' }),
        onSuccess: (_data, target) => {
            queryClient.setQueryData(KEY, (catalog) => catalog?.map((screen) => screen.screen === target.screen
                ? {
                    ...screen,
                    variants: screen.variants.filter((variant) => variant.variant !== target.variant),
                }
                : screen));
        },
    });
}
